<template>
  <div class="login-actions">
    <router-link :to="route">{{ $t('forgot.password') }}</router-link>
  </div>
</template>

<script>
import { ROUTER_PATHS } from '@/router/constants';

export default {
  props: {
    email: String,
  },
  computed: {
    route() {
      return {
        path: ROUTER_PATHS.RECOVERY_PASSWORD,
        query: {
          email: this.email,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.login-actions {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>